import { ITag, IUserSubscribedTags } from '@koomzo/coremodel';
import { State, Selector, Action, StateContext, NgxsOnInit, Store } from '@ngxs/store';
import { TagDbService } from '@shared/services';
import { LoadUserSubscribedTags, LoadTags, UpdateUserSubscribedTags } from './tag.actions';
import { UserSubscribedTagsDbService } from '../services/user-subscribed-tags-db.service';
import { of, from, tap, catchError } from 'rxjs';
import { IUser } from '@koomzo/commonmodel';
import { Injectable } from '@angular/core';

export class TagStateModel {
  hasLoaded: boolean;
  tags?: ITag[];
  userSubscribedTags: IUserSubscribedTags;
}

@State<TagStateModel>({
  name: 'tagState',
  defaults: {
    hasLoaded: false,
    tags: [],
    userSubscribedTags: null
  }
})
@Injectable()
export class TagState implements NgxsOnInit {
  @Selector()
  static tags(state: TagStateModel) {
    return state.tags;
  }

  @Selector()
  static subscribedTags(state: TagStateModel) {
    return state.userSubscribedTags;
  }

  constructor(private _store: Store, private tagService: TagDbService, private _userSubscribedTagsDbService: UserSubscribedTagsDbService) {}

  ngxsOnInit(ctx?: StateContext<TagStateModel>) {}

  @Action(LoadTags)
  loadTags(ctx: StateContext<TagStateModel>, action: LoadTags) {
    return this.tagService.get().pipe(
      tap((result: ITag[]) => {
        const state = ctx.getState();
        let pResult = [];
        if (!result) {
          pResult = [{}];
        } else {
          pResult = result;
        }
        ctx.patchState({ ...state, tags: pResult });
      })
    );
  }

  @Action(LoadUserSubscribedTags)
  loadUserSubscribedTags(ctx: StateContext<TagStateModel>, action: LoadUserSubscribedTags) {
    console.log('loadUserSubscribedTags action');
    const user = this._store.selectSnapshot<IUser>((state: any) => state.authState.user);
    return this._userSubscribedTagsDbService.getUserSubscribedTags(user.id).pipe(
      tap((result: IUserSubscribedTags) => {
        const state = ctx.getState();
        ctx.patchState({ ...state, userSubscribedTags: result });
      }),
      catchError(err => {
        console.log('load users subscribed tags error', err);
        return of([]);
      })
    );
  }

  @Action(UpdateUserSubscribedTags)
  updateUserSubscribedTags(ctx: StateContext<TagStateModel>, { payload }: UpdateUserSubscribedTags) {
    const data = { ...payload };
    return from(this._userSubscribedTagsDbService.addOrUpdate(data)).pipe(
      tap((res: IUserSubscribedTags) => {
        const state = ctx.getState();
        ctx.patchState({ ...state, userSubscribedTags: res });
      })
    );
  }
}
